import React from 'react';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import fileGreenIcon from '../../../styles/svgs/uploaded-file.svg';
import { DATE_FORMAT_DISPLAY } from '../../../constants';
import MainButton from '../../MUI/MainButton';
import ExistingContractsIcon from '../../../img/formSectionIcons/existingContracts.svg';
import FormSection from '../../FormComponents/FormSection';

import styles from './styles.module.scss';

const ExistingContracts = ({ existingContracts, updateContract, errors, contract, classes }) => {
  const { t } = useTranslation();

  const handleUpdateContract = (existingContract) => {
    if (!existingContract.isDisabled) {
      updateContract(existingContract);
    }
  };

  return (
    <div className={classes.content}>
      <FormSection title="claim.accInfo.existingContracts" icon={ExistingContractsIcon}>
        <div className={styles.existingContracts}>
          {existingContracts.filter((contract) => !contract.nonMatching).map((existingContract) => (
            <div key={existingContract.policyNumber} className={styles.contractData}>
              <div className={styles.leftBlock}>
                <div className={styles.contractLogo}>
                  <img src={fileGreenIcon} alt="Contract" />
                </div>
              </div>
              <div className={styles.rightBlock}>
                <div className={styles.contractDetails}>
                  <div className={styles.content}>
                    <p className={styles.label}>{t('claim.accInfo.insurer')}</p>
                    <p className={styles.insurer}>{existingContract.insurer}</p>
                  </div>
                  <div className={styles.content}>
                    <p className={styles.label}>{t('claim.accInfo.contractNumber')}</p>
                    <p>{existingContract.policyNumber}</p>
                  </div>
                  <div className={styles.content}>
                    <p className={styles.label}>{t('claim.accInfo.contractDate')}</p>
                    <p>
                      {format(new Date(existingContract.startDate), DATE_FORMAT_DISPLAY)}
                      {' - '}
                      {format(new Date(existingContract.endDate), DATE_FORMAT_DISPLAY)}
                    </p>
                  </div>
                </div>
                <div className={styles.buttonContainer}>
                  <MainButton
                    variant={
                      contract && contract.policyNumber === existingContract.policyNumber
                        ? 'outlined'
                        : 'contained'
                    }
                    color="primary"
                    size="small"
                    disabled={existingContract.policyNumber === contract?.policyNumber || false}
                    onClick={() => handleUpdateContract(existingContract)}
                  >
                    {contract && contract.policyNumber === existingContract.policyNumber
                      ? t('claim.button.selected')
                      : t('claim.button.select')}
                  </MainButton>
                </div>
              </div>
            </div>
          ))}
        </div>
        {errors.contract && !contract && (
          <p className={styles.errorText}>{t(errors.contract.message)}</p>
        )}
      </FormSection>
    </div>
  );
};

ExistingContracts.propTypes = {
  existingContracts: PropTypes.arrayOf(
    PropTypes.shape({
      policyNumber: PropTypes.string,
    }),
  ).isRequired,
  contract: PropTypes.shape({
    policyNumber: PropTypes.string,
    nonMatching: PropTypes.bool,
  }),
  errors: PropTypes.shape({
    contract: PropTypes.shape({
      message: PropTypes.string,
    }),
  }).isRequired,
  updateContract: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    content: PropTypes.string,
    rowTitle: PropTypes.string,
  }).isRequired,
};

ExistingContracts.defaultProps = {
  contract: {},
};

export default ExistingContracts;
